import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { PropTypes } from "prop-types";
import { Stack } from "@mui/material";
import isAccess from "../../shared/components/CheckUserRights";

const ListItemLink = (props) => {
  const { icon, primary, onClick, selected, to } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <ListItem
      selected={selected}
      button
      component={renderLink}
      disablePadding
      sx={{
        minHeight: "70px"
      }}
      onClick={onClick}>
      <Stack direction="row">
        {icon ? <ListItemIcon sx={{ ml: 2, minWidth: "0" }}>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </Stack>
    </ListItem>
  );
};

ListItemLink.propTypes = {
  icon: PropTypes.element,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  onclick: PropTypes.func,
  selected: PropTypes.bool.isRequired
};

const FelixAdminConfiguration = (props) => {
  const location = useLocation();
  const felixAdminConfig = [
    {
      title: "PATIENT PORTAL ADMIN",
      url: "/admin/patient-portal-admin",
      text: "Patient Portal Payment",
      icon: "/Assets/payment.png",
      screenRights: "ptpla"
    }
    // {
    //   title: "STAFF ADMIN",
    //   url: "/admin/staff-admin",
    //   text: "Staff Admin",
    //   icon: "/Assets/practice.png",
    //   screenRights: "sfa"
    // }
    // {
    //   title: "DOCUMENT LIBRARY",
    //   url: "/admin/document-library",
    //   text: "Document Library",
    //   icon: "/Assets/payment.png"
    // }
  ];

  const selectedPath = felixAdminConfig.findIndex((item) => item.url === location.pathname);

  const [selectedIndex, setSelectedIndex] = useState(selectedPath);

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };
  return (
    <Box className="sidebar-container">
      <List disablePadding>
        {felixAdminConfig.map(
          ({ title, text, url, icon, screenRights }, index) =>
            isAccess(screenRights) && (
              <ListItemLink
                key={index}
                selected={selectedIndex === index}
                onClick={() => {
                  handleListItemClick(index);
                  props.getSelectedConfig(text);
                }}
                to={url}
                primary={title}
                icon={<img src={icon} alt="" />}
              />
            )
        )}
      </List>
    </Box>
  );
};

export default FelixAdminConfiguration;
